<template>
    <v-dialog
      v-model="State.loading"
      persistent
      width="300">
        <v-card
            color="primary"
            dark>
            <v-card-text>
                Please Wait...
                <v-progress-linear
                indeterminate
                color="white"
                class="mb-0">
                </v-progress-linear>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
import State from '../../services/state'

export default {
    name: 'Halter',
    data() {
        return {
            State
        }
    }
}
</script>